// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { ResponseMessageSchema, StatusSchema } from "./utilitySchemas";
import { StripePriceListSchema } from "./pricelistSchemas";

export const SiteSourceEnum = z.enum([
	"FAZ",
	"Gutachten_org",
	"Immoportal",
	"derGutachter",
	"Evalion",
	"RentalOne",
	"Vermieterwelt",
	"DealPilot",
	"PunktImmo",
	"Holfert_WP",
	"Immocation",
	"EOTA",
]);

export type SiteSource = z.infer<typeof SiteSourceEnum>;

export const PartnerSitesSchema = z.object({
	source: SiteSourceEnum,
	label: z.string().optional(), // Optional label for display purposes
	platformFee: z.number().optional(),
});

export const DefaultPartnerSitesSchema = z.object({
	FAZ: PartnerSitesSchema.optional(),
	Gutachten_org: PartnerSitesSchema.optional(),
	Immoportal: PartnerSitesSchema.optional(),
	derGutachter: PartnerSitesSchema.optional(),
	RentalOne: PartnerSitesSchema.optional(),
	Vermieterwelt: PartnerSitesSchema.optional(),
	DealPilot: PartnerSitesSchema.optional(),
	PunktImmo: PartnerSitesSchema.optional(),
	Holfert_WP: PartnerSitesSchema.optional(),
	Immocation: PartnerSitesSchema.optional(),
	EOTA: PartnerSitesSchema.optional(),
});

export const PartnerHmacCredentialStatusEnum = z.enum(["ACTIVE", "REVOKED"]);

export const PartnerHmacCredentialSchema = z.object({
	id: z.string(),
	keyId: z.string(),
	secretHint: z.string(),
	status: PartnerHmacCredentialStatusEnum,
	createdAt: z.string(),
	updatedAt: z.string(),
	revokedAt: z.string().nullable(),
	partnerSiteId: z.string(),
});

export type PartnerHmacCredential = z.infer<
	typeof PartnerHmacCredentialSchema
>;

export const PartnerHmacCredentialWithSecretSchema =
	PartnerHmacCredentialSchema.extend({
		secret: z.string(),
	});

export type PartnerHmacCredentialWithSecret = z.infer<
	typeof PartnerHmacCredentialWithSecretSchema
>;

export const PartnerReportingApiCredentialStatusEnum = z.enum([
	"ACTIVE",
	"REVOKED",
]);

export const PartnerReportingApiCredentialSchema = z.object({
	id: z.string(),
	keyHint: z.string(),
	status: PartnerReportingApiCredentialStatusEnum,
	createdAt: z.string(),
	updatedAt: z.string(),
	lastUsedAt: z.string().nullable(),
	revokedAt: z.string().nullable(),
});

export type PartnerReportingApiCredential = z.infer<
	typeof PartnerReportingApiCredentialSchema
>;

export const PartnerReportingApiCredentialWithKeySchema =
	PartnerReportingApiCredentialSchema.extend({
		apiKey: z.string(),
	});

export type PartnerReportingApiCredentialWithKey = z.infer<
	typeof PartnerReportingApiCredentialWithKeySchema
>;

export type DefaultPartnerSites = z.infer<typeof DefaultPartnerSitesSchema>;

export const DuplicatePartnerSitePriceListSchema = z.object({
	priceListId: z.string(),
	name: z.string(),
	source: SiteSourceEnum,
});

export type DuplicatePartnerSitePriceList = z.infer<
	typeof DuplicatePartnerSitePriceListSchema
>;

export const PartnerSitePriceListSchema = z.object({
	id: z.string(),
	priceListId: z.string(),
	source: SiteSourceEnum,
	platformFee: z.number(),
	updatedAt: z.string(),
	createdAt: z.string(),
	priceList: StripePriceListSchema.nullable(),
	hmacCredentials: z.array(PartnerHmacCredentialSchema).optional(),
});

export type PartnerSitePriceList = z.infer<typeof PartnerSitePriceListSchema>;

export const PartnerSitePriceListsResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: z.array(PartnerSitePriceListSchema),
});

export const PartnerSitePriceListResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: PartnerSitePriceListSchema,
});

export const PartnerHmacCredentialsResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: z.array(PartnerHmacCredentialSchema),
});

export const PartnerHmacCredentialResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: PartnerHmacCredentialSchema,
});

export const PartnerHmacCredentialWithSecretResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: PartnerHmacCredentialWithSecretSchema,
});

export const PartnerReportingApiCredentialsResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: z.array(PartnerReportingApiCredentialSchema),
});

export const PartnerReportingApiCredentialResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: PartnerReportingApiCredentialSchema,
});

export const PartnerReportingApiCredentialWithKeyResponseSchema = z.object({
	status: StatusSchema,
	message: ResponseMessageSchema,
	data: PartnerReportingApiCredentialWithKeySchema,
});

export const PartnerSiteQuerySchema = z.object({
	limit: z.coerce.number().int().positive().optional(),
	offset: z.coerce.number().int().nonnegative().optional(),
	sortBy: z.enum(["id", "priceList", "platformFee", "createdAt", "updatedAt", 'source']).optional(),
	sortOrder: z.enum(["asc", "desc"]).optional(),
	filter: z
    .object({
      assigned: z
        .union([
          z.boolean(),
          z.enum(["true", "false"]).transform((val) => val === "true"),
        ])
        .optional(),
		source: SiteSourceEnum.optional(),
    })
    .optional(),
});

export type PartnerSiteQuery = z.infer<typeof PartnerSiteQuerySchema>;

export const PartnerSiteUpdateSchema = z.object({
	platformFee: z
		.number()
		.min(0, { message: "Platform fee cannot be less than 0%" })
		.max(100, { message: "Platform fee cannot exceed 100%" })
		.optional()
		.nullable(),
});

export type PartnerSiteUpdate = z.infer<typeof PartnerSiteUpdateSchema>;
